import React from 'react';
import NavigationContainer from './Navigation/index';
import Footer from './Footer';
import SocialShare from './SocialShare';
import MobileUtilityBar from './MobileUtilityBar';
import AlertBanner from './AlertBanner';
import MultiAlertBanner from './MultiAlertBanner';
import PageScrollIndicator from './PageScrollIndicator';

const Components = {
    component___navigation: NavigationContainer,
    component___footer: Footer,
    component___alert_banner: AlertBanner,
    component___multi_alert_banner: MultiAlertBanner,
    component___social_share: SocialShare,
    component___mobile_utility_bar: MobileUtilityBar,
    component___page_scroll_indicator: PageScrollIndicator,
};

const NavigationComponent = ({
    name,
    kontentItemId,
    ...props
}: {
    name: string;
    kontentItemId?: string;
    [key: string]: any;
}) => {
    //@ts-ignore
    let Component = Components[name];

    if (!Component) {
        return null;
    }

    return <Component kontentItemId={kontentItemId} {...props} />;
};

export default NavigationComponent;
